@if (crumbs.length > 0) {
  <div class="breadcrumb-card mb-0 d-flex align-items-center">
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0 d-flex align-items-center">
      @for (crumb of crumbs; track trackByUrl($index, crumb); let isLast = $last) {
        <li
          class="breadcrumb-item position-relative"
          [class.active]="crumb.isActive"
          >
          @if (!crumb.isActive) {
            <a
              href="javascript:void(0)"
              class="d-inline-block position-relative"
              [matTooltip]="'Kliknite za navigaciju na ' + crumb.label"
              (click)="onCrumbClick(crumb)"
              >
              @if (crumb.icon) {
                <i class="material-symbols-outlined me-1">{{ crumb.icon }}</i>
              }
              {{ crumb.label }}
            </a>
          } @else {
            <span class="d-inline-block">
              @if (crumb.icon) {
                <i class="material-symbols-outlined me-1">{{ crumb.icon }}</i>
              }
              {{ crumb.label }}
            </span>
          }
        </li>
      }
    </ol>
  </div>
}
